export const REPLY_PREVIEW_MAX_CHARS = 60;
